<template>
    <div class="training-step2">
        <div class="training-step2-title">
            <img src="@/assets/images/icon_zhuangshi@2x.png" alt="">
            <span>活动安排</span>
        </div>
        <div class="training-step-right-btns" v-if="formData.status !== 7">
            <el-button size="mini" @click="addMS">添加面授</el-button>
            <el-button size="mini" @click="addKC">添加课程</el-button>
            <el-button size="mini" @click="addKS">添加考试</el-button>
            <el-button size="mini" @click="addZY">添加作业</el-button>
            <el-button size="mini" @click="addDY">添加调研</el-button>
        </div>
        <div class="training-step-table">
            <el-table :data="formData.trainActivitys" style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="activityName" label="活动名称">
                    <template slot="header" slot-scope="scope">
                        <span class="red" v-if="formData.status !== 7">*</span>
                        <span>活动名称</span>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="formData.status === 7">{{scope.row.activityName}}</span>
                        <el-input v-if="formData.status !== 7" class="table-act-name" v-model="scope.row.activityName" placeholder="请输入活动名称"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="类型" width="100">
                    <template slot-scope="scope">
                        <span>{{typeObj[scope.row.type]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="date" label="开始时间" width="180">
                    <template slot="header" slot-scope="scope">
                        <span class="red" v-if="formData.status !== 7">*</span>
                        <span>开始时间</span>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="formData.status === 7">{{scope.row.startTime}}</span>
                        <el-date-picker v-if="formData.status !== 7" v-model="scope.row.startTime" type="datetime" placeholder="请选择开始时间" :clearable="false" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column prop="endTime" label="结束时间" width="180">
                    <template slot="header" slot-scope="scope">
                        <span class="red" v-if="formData.status !== 7">*</span>
                        <span>结束时间</span>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="formData.status === 7">{{scope.row.endTime}}</span>
                        <el-date-picker v-if="formData.status !== 7" v-model="scope.row.endTime" type="datetime" placeholder="请选择结束时间" :clearable="false" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column prop="lectorName" label="讲师" width="120"></el-table-column>
                <el-table-column prop="compulsory" label="必/选修" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="red" v-if="formData.status !== 7">*</span>
                        <span>必/选修</span>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="formData.status === 7">{{scope.row.compulsory?'必修':'选修'}}</span>
                        <el-select v-if="formData.status !== 7" v-model="scope.row.compulsory" placeholder="请选择必/选修">
                            <el-option label="选修" :value="0"></el-option>
                            <el-option label="必修" :value="1"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="action" label="操作" width="150" v-if="formData.status !== 7">
                    <template slot-scope="scope">
                        <div class="table-btn table-btn-view">
                            <i class="el-icon-view"></i>
                            <span>查看</span>
                        </div>
                        <div class="table-btn table-btn-delete" @click="deleteItem(scope.$index)">
                            <i class="el-icon-delete"></i>
                            <span>删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="training-step-btns" v-if="formData.status !== 7">
            <el-button type="primary" size="mini" @click="saveStep">保存</el-button>
        </div>
        <!-- 面授 -->
        <faceDailog
            :visible="faceDailogObj.visible"
            @closeDailog="faceDailogObj.visible = false"
            @confirmDailog="handleFaceDialogSave"></faceDailog>
        <!-- 课程 -->
        <courseDialog
            :visible="courseDialogObj.visible"
            @closeDailog="courseDialogObj.visible = false"
            @confirmDailog="handleCourseDialogSave"></courseDialog>
        <!-- 考试 -->
        <examDialog
            :visible="examDialogObj.visible"
            :questionItems="examDialogObj.questionItems"
            :examPaperId="examDialogObj.examId"
            :configIds="examDialogObj.configIds"
            @closeDialog="examDialogObj.visible = false"
            @confirmDailog="handleExamDialogSave"
            @examTypeChange="examTypeChange"
        ></examDialog>
        <!-- 试题组 -->
        <paperDialog
            :visible="exam1Dialog.visible"
            :questionData="exam1Dialog.questionData"
            @closeDialog="exam1Dialog.visible = false"
            @confirmDialog="handleExam1DialogSave"
            @chooseSubjectItems="handleSubjectDialogShow"
            @addSubjectItem="handleAddSubjectDialogShow"></paperDialog>
        <!-- 试题列表 -->
        <subjectListDialog
            :visible="subjectDialog.visible"
            @closeDailog="subjectDialog.visible = false"
            @confirmDailog="handleSubjectDialogSave"></subjectListDialog>
        <!-- 新增试题 -->
        <addSubjectDailog
            :visible="addSubjectDialog.visible"
            @closeDialog="addSubjectDialog.visible = false"
            @confirmDailog="handleAddSubjectDialogSave"></addSubjectDailog>
        <!-- 随机试卷 -->
        <chooseRanomPaper
            :visible="exam2Dialog.visible"
            @closeDailog="exam2Dialog.visible = false"
            @confirmDailog="handleExam2DialogSave"></chooseRanomPaper>
        <!-- 选择试卷 -->
        <choosePaperDialog
            :visible="exam3Dialog.visible"
            @closeDailog="exam3Dialog.visible = false"
            @confirmDailog="handleExam3DialogSave"
        ></choosePaperDialog>
        <!-- 调研 -->
        <queDialog
            :visible="researchDialog.visible"
            @closeDailog="researchDialog.visible = false"
            @confirmDailog="handleResearchDialogSave"></queDialog>
        <!-- 作业 -->
        <jobDialog
            :visible="jobDialogObj.visible"
            @closeDailog="jobDialogObj.visible = false"
            @confirmDailog="handleJobDialogSave"></jobDialog>
        
    </div>
</template>
<script>
import pagination from '@/components/pagination/index'
import oosUpload from '@/components/oosUpload/index.vue'
import faceDailog from './faceDialog' // 面授
import courseDialog from './courseDialog' // 课程
import examDialog from './examDialog' // 考试
import paperDialog from './paperDialog' // 试题组
import chooseRanomPaper from './chooseRanomPaper' // 选择随机组
import choosePaperDialog from './choosePaperDialog' // 选试卷
import subjectListDialog from './subjectListDialog' // 题目弹窗
import addSubjectDailog from './addSubjectDialog' // 新增试题
import jobDialog from './jobDialog' // 作业
import queDialog from './queDialog' // 调研

export default {
    name: 'TrainingStep2',
    props: ['formData', 'userList'],
    components: {
        pagination,
        oosUpload,
        faceDailog,
        courseDialog,
        examDialog,
        paperDialog,
        chooseRanomPaper,
        choosePaperDialog,
        subjectListDialog,
        addSubjectDailog,
        jobDialog,
        queDialog 
    },
    data() {
        return {
            typeObj: { 1: '课程', 2: '作业', 3: '调研', 4: '考试', 5: '面授' },
            faceDailogObj: {
                visible: false
            },
            courseDialogObj: {
                visible: false
            },
            examDialogObj: {
                visible: false,
                questionItems: [],
                examId: null,
                configIds: []
            },
            exam1Dialog: {
                visible: false,
                questionData: []
            },
            subjectDialog: {
                visible: false
            },
            addSubjectDialog: {
                visible: false
            },
            exam2Dialog: {
                visible: false
            },
            exam3Dialog: {
                visible: false,
            },
            researchDialog: {
                visible: false
            },
            jobDialogObj: {
                visible: false,
            },
            examRefresh: false
        }
    },
    methods: {
        // 添加面授
        addMS() {
            this.faceDailogObj.visible = true
        },
        // 添加课程
        addKC() {
            this.courseDialogObj.visible = true
        },
        // 添加考试
        addKS() {
            this.examDialogObj.examId = null
            this.examDialogObj.configIds = []
            this.examDialogObj.questionItems = []
            this.examDialogObj.visible = true
        },
        // 添加作业
        addZY() {
            this.jobDialogObj.visible = true
        },
        // 添加调研
        addDY() {
            this.researchDialog.visible = true
        },
        // 删除表格
        deleteItem(index) {
            this.formData.delActivityIds.push(this.formData.trainActivitys[index].id)
            this.formData.trainActivitys.splice(index, 1)
        },
        // 弹窗-面授
        handleFaceDialogSave(form) {
            this.formData.trainActivitys.push({
                activityName: form.activityName,
                classroom: form.classroom,
                lectorId: form.lectorId,
                instructions: form.instructions,
                startTime: form.timeRange[0],
                endTime: form.timeRange[1],
                type: 5,
                compulsory: 1
            })
        },
        // 弹窗-课程保存
        handleCourseDialogSave(selectTable) {
            if (selectTable && selectTable.length > 0) {
                for (let item of selectTable) {
                    this.formData.trainActivitys.push({
                        activityName: item.title,
                        compulsory: 1,
                        startTime: '',
                        endTime: '',
                        targetId: item.id,
                        type: 1
                    })
                }
            }
        },
        // 考试题选择
        examTypeChange(type, isRefresh) {
            this.examRefresh = isRefresh
            if (type === 1) {
                this.exam1Dialog.questionData = []
                this.exam1Dialog.visible = true
            }
            if (type === 2) {
                this.exam2Dialog.visible = true
            }
            if (type === 3) {
                this.exam3Dialog.visible = true
            }
        },
        // 弹窗-考试保存
        handleExamDialogSave(form) {
            this.formData.trainActivitys.push({
                activityName: form.title,
                exam: JSON.parse(JSON.stringify(form)),
                startTime: form.timeRange[0],
                endTime: form.timeRange[1],
                type: 4,
                compulsory: 1
            })
            this.examDialogObj.visible = false
        },
        // 选择试题组卷
        handleExam1DialogSave(data, val) {
            if (this.examRefresh) {
                this.examDialogObj.examId = null
                this.examDialogObj.configIds = []
            }
            this.examDialogObj.questionItems = data
            this.exam1Dialog.visible = false
        },
        // 题目弹出
        handleSubjectDialogShow() {
            this.subjectDialog.visible = true
        },
        // 题目选择
        handleSubjectDialogSave(data) {
            if (data.length) {
                this.exam1Dialog.questionData = this.$wtUtil.unique([...this.exam1Dialog.questionData, ...data], 'id')
            }
            if (this.examRefresh) {
                this.examDialogObj.examId = null
                this.examDialogObj.configIds = []
            }
            this.subjectDialog.visible = false
        },
        // 题目新增弹出
        handleAddSubjectDialogShow() {
            this.addSubjectDialog.visible = true
        },
        // 题目新增
        handleAddSubjectDialogSave() {
        },
        // 选择随机试卷
        handleExam2DialogSave(data, val) {
            if (this.examRefresh) {
                this.examDialogObj.examId = null
                this.examDialogObj.configIds = []
            }
            this.examDialogObj.questionItems = data
            this.examDialogObj.configIds = val
            this.exam2Dialog.visible = false
        },
        // 选择试卷
        handleExam3DialogSave(data) {
            if (this.examRefresh) {
                this.examDialogObj.examId = null
                this.examDialogObj.configIds = []
            }
            this.examDialogObj.examId = data.id
            this.examDialogObj.questionItems = data.subjects
            this.exam3Dialog.visible = false
        },
        // 弹窗-调研保存
        handleResearchDialogSave(selectTable) {
            if (selectTable && selectTable.length > 0) {
                for (let item of selectTable) {
                    this.formData.trainActivitys.push({
                        activityName: item.title,
                        compulsory: 1,
                        startTime: '',
                        endTime: '',
                        targetId: item.id,
                        type: 3
                    })
                }
            }
        },
        // 弹窗-作业保存
        handleJobDialogSave(form) {
            this.formData.trainActivitys.push({
                activityName: form.workName,
                workName: form.workName,
                workDesc: form.workDesc,
                workFiles: form.workFiles,
                startTime: form.timeRange[0],
                endTime: form.timeRange[1],
                type: 2,
                compulsory: 1
            })
        },
        saveStep() {
            this.$emit('saveStep')
        },
        // 转换讲师
        transTearcherName(id) {
            let str = '-'
            for (let item of this.userList) {
                if (item.id == id) {
                    str = item.realname
                    break
                }
            }
            return str
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../../styles/variables.scss';

.training-step2 {
    background: $white_bg_color;
    .training-step2-title {
        padding: .1rem .1rem .16rem;
        font-size: .18rem;
        color: $font__color_000;
        img {
            width: .22rem;
            margin-right: .1rem;
            vertical-align: middle;
        }
    }
    .training-step-right-btns {
        text-align: right;
        padding-right: .22rem;
        height: .3rem;
        margin-bottom: .12rem;
        .el-button--mini {
            vertical-align: top;
            width: .8rem;
            padding: .07rem .1rem;
        }
    }
    .training-step-table {
        padding: 0 .22rem 0 .1rem;
    }
    .training-step-btns {
        height: .83rem;
        padding: .24rem 0 .3rem;
        border-top: 1px solid $grey_border_color_e6;
        text-align: center;
        .el-button {
            vertical-align: top;
            width: .9rem;
        }
    }
}
</style>
<style lang="scss">
@import '../../../../styles/variables.scss';

.training-step2 {
    .training-step-table {
        .red {
            margin-right: .04rem;
            color: $font_color_F0;
        }
        .el-table {
            margin-bottom: .3rem;
            th {
                background: $grey_bg_color_f5;
            }
            td, th {
                padding: .1rem 0;
            }
            thead {
                color: $font_color_4A;
            }
            td, th.is-leaf {
                border: 0;
            }
            &::before {
                height: 0;
            }
            .table-btn {
                display: inline-block;
                font-size: .13rem;
                cursor: pointer;
                &:hover {
                    opacity: .8;
                }
                i {
                    font-size: .16rem;
                    vertical-align: text-bottom;
                }
                >span {
                    margin-left: .04rem;
                }
            }
            .table-btn-delete {
                color: $font_color_2A;
            }
            .table-btn-view {
                color: $font_color_51b;
                margin-right: .3rem;
            }
            .table-act-name {
                width: 1.95rem;
            }
            .el-input__inner {
                height: .35rem;
                line-height: .35rem;
            }
            .el-date-editor.el-input, .el-date-editor.el-input__inner {
                width: 1.68rem;
            }
            .el-icon-time {
                display: none;
            }
            .el-input--prefix .el-input__inner {
                padding-left: .15rem;
                padding-right: .15rem;
            }
            .el-input__icon {
                line-height: .35rem;
            }
        }
    }
    .step-audit-dialog {
        .user-step-dialog-form {
            margin-top: .4rem;
            .el-input,.el-textarea,.el-date-editor {
                width: 4rem;
            }
            .el-form-item {
                margin-bottom: .15rem;
            }
            .el-textarea__inner {
                height: .8rem;
            }
        }
        .dialog-footer {
            padding: .15rem .2rem;
            border-top: 1px solid $grey_border_color_e6;
            text-align: right;
            .el-button {
                width: .9rem;
                vertical-align: top;
            }
        }
        .training-step-table {
            padding: 0 .2rem;
        }
        .user-step-search-form {
            margin-top: .2rem;
            .el-input {
                width: 1.7rem;
            }
            .el-form-item {
                margin-bottom: .2rem;
            }
            .search-itrm-btn {
                margin-left: .6rem;
                .reset-btn {
                    color: $font_color_A6;
                }
            }
            .search-item-long-btn {
                margin-left: 3.36rem;
            }
        }
        .user-step-split-form {
            margin-top: .2rem;
            .el-form-item {
                margin-right: 0;
            }
            .form-left-item {
               .el-form-item__label {
                   width: 1.6rem;
               } 
            }
            .form-right-item {
               .el-form-item__label {
                   width: 1.5rem;
               } 
            }
            .form-subject-left-item {
               .el-form-item__label {
                   width: 1.6rem;
               }
               .el-input {
                    width: 2.4rem;
                }
               .el-input-number {
                   width: 2.4rem;
               }
               .el-textarea {
                   width: 6.4rem;
               }
               .el-options-table, .el-oos-upload {
                   width: 8.4rem;
               }
               .el-table-input {
                    width: 100%;
                }
            }
            .el-input {
                width: 2.4rem;
            }
            .job-time-item.el-range-editor {
                width: 2.4rem;
            }
            .el-textarea {
                width: 6.17rem;
            }
        }
        .step-exam-border {
            padding: .2rem .2rem 0 .5rem;
        }
        .step-exam-item-btn {
            padding: .2rem;
        }
        .step-exam-group {
            padding: 0 .2rem;
        }
        
        .section-questionData {
           box-shadow: 0 .02rem .12rem 0 rgba(0,0,0,.1);
            padding: .2rem 0;
            width: 100%;
            .items {
                margin-bottom: .1rem;
                padding: 0 .2rem;
                .header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .name {
                        margin-bottom: .1rem;
                        flex: 1;
                        padding-right: .5rem;
                        span {
                            color: #333;
                            margin-left: .1rem;
                        }
                    }
                }
                .options--items {
                    display: inline-block;
                    box-sizing: border-box;
                    width: 50%;
                    padding: .1rem;
                }
            }
        }
    }
}
</style>
